import React from 'react';
import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import OfferDeclinedImg from '../../../../../Assets/AuthBackGround/OfferDeclined.png';
import RejectedImg from '../../../../../Assets/AuthBackGround/Rejected.png';

const statusConfig = {
    declined: {
        img: OfferDeclinedImg,
        alt: 'Offer Declined',
        messages: [
            'As you have declined the offer, this page is no longer accessible.',
            'For any further clarification or assistance, please reach out to HR team.'
        ]
    },
    rejected: {
        img: RejectedImg,
        alt: 'Offer Rejected',
        messages: [
            'This link is currently inaccessible.',
            'Please contact HR team for further assistance.'
        ]
    }
};

const StatusMessage: React.FC = () => {
    const location = useLocation();
    const type = location.state?.type === 'declined' ? 'declined' : 'rejected';
    const { img, alt, messages } = statusConfig[type];

    return (
        <Box
            sx={{
                height: "100vh",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column"
            }}
        >
            <Box
                component="img"
                src={img}
                alt={alt}
                sx={{ width: "10vw", height: "auto", mb: 2 }}
            />
            {messages.map((msg, idx) => (
                <Typography key={idx} variant='h6' color={'#475467'}>
                    {msg}
                </Typography>
            ))}
        </Box>
    );
};

export default StatusMessage;